import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_REPORT_PRESENTED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
  REPORT_TYPE: '',
});

const RECORD = generateSchema(TRACKING_REPORT_PRESENTED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_REPORT_PRESENTED_SCHEMA);

export class ReportPresentedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.presented;
  }

  get properties() {
    return this.toJS();
  }
}
